import serverVars from 'server-vars';
import { useEffect } from 'react';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

import { getDwelledOnPage, setDwelledOnPageFlag } from '../helpers/loginPromptHelpers';

const DWELL_ON_PDP_LIMIT_DESKTOP = 22000;
const DWELL_ON_PDP_LIMIT_MOBILE = 19000;

const DWELL_ON_HOMEPAGE_LIMIT = 11000;

const DWELL_ON_SB_LIMIT_DESKTOP = 28000;
const DWELL_ON_SB_LIMIT_MOBILE = 27000;

export type DwellPageType = typeof PAGE_TYPE.HOME | typeof PAGE_TYPE.SEARCH | typeof PAGE_TYPE.PDP;

const handleDwellTimeout = (pageType: DwellPageType): void => {
    setDwelledOnPageFlag(pageType);
};

export const setDwelledOnPage = (pageType: DwellPageType): NodeJS.Timeout | undefined => {
    if (!getDwelledOnPage(pageType)) {
        const isMobile = serverVars.get('settings.isMobile');
        let dwellTimeLimit;
        switch (pageType) {
            case PAGE_TYPE.PDP:
                dwellTimeLimit = isMobile ? DWELL_ON_PDP_LIMIT_MOBILE : DWELL_ON_PDP_LIMIT_DESKTOP;
                break;
            case PAGE_TYPE.HOME:
                dwellTimeLimit = DWELL_ON_HOMEPAGE_LIMIT;
                break;
            case PAGE_TYPE.SEARCH:
                dwellTimeLimit = isMobile ? DWELL_ON_SB_LIMIT_MOBILE : DWELL_ON_SB_LIMIT_DESKTOP;
                break;
        }

        return setTimeout(() => handleDwellTimeout(pageType), dwellTimeLimit);
    }
    return undefined;
};

export const useDwelledOnPage = (pageType: DwellPageType): void => {
    useEffect(() => {
        const timeoutId = setDwelledOnPage(pageType);
        return () => clearTimeout(timeoutId);
    }, [pageType]);
};
